import { useEffect, useRef } from "react";

const AdBanner = ({ adSlot }) => {
  const adRef = useRef(null);

  useEffect(() => {
    try {
      if (adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      data-ad-client="ca-pub-xxxxxxxxxxxxxxxx"
      data-ad-slot={adSlot}
      data-ad-format="auto"
      data-full-width-responsive="true"
      style={{ display: "block" }}
    ></ins>
  );
}

export default AdBanner;